// extracted by mini-css-extract-plugin
export default {"select":"RangeSelect_select__7JlOQ"};